/**
 *Created by jmmartinez on 18/03/19
 *  v 1.1 12/06/2019 Añadido evento onBeforeSave
 *  v 1.2 20/08/2019 Modificados nombres de eventos On
 *  v 1.3 01/10/2019 Eliminado nombre del elemento en el render (Se pasa al formulario)
 *                   Eliminado el import de formulariodatos.css
 *  v.1.4 10/02/2020 Añadido dialogoTitulo, dialogoTexto, dialogoTipo y onDialogoCerrado a las props.
 *                   Añadidas las propiedades anteriores a la llamada a FormularioDatos
 *  v.1.5 06/04/2020 Añadida funcion onAntesCargarDatos en prop.
 *  v.1.6 28/07/2020 En render, si se trata de la accion == ACCION_NUEVO, no mostramos las pestañas adicionales.
 *  v.1.7 30/07/2020 Añadida la propiedad onPermitirAceptar.
 *                   Transmitida la propiedad onPermitirAceptar a <FormularioDatos
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  19/10/2020 Creada la propiedad usuario necesaria para la llamada al backend
 * v.2.2  17/04/2022 Añadido uso de la propiedad icon en los formularios children para insertarlo en el titulo del tab.
 *
 * v.2.3  06/05/2022 Fusion Sidemur y Planifikator
 * v.2.4  04/05/2022 En render, modificada la llamada <Tab id="datos"  para indicar en el title un Icono:  title={<><Icon icon="paperclip"/> Datos </>}
 * v.2.5  07/07/2022 En MapStateToProps añadido: auth: state.auth,
 *                   En Render, en Tabs, añadimos la condición para mostrar la pestaña: let mostrar= (!child.props.menuid || (accionesUsuario && accionesUsuario.includes(" " + child.props.menuid + " "))  )
 * v.2.6  02/08/2022 En Render, en Tabs, añadimos la condición  !esNuevo par mostrar los childrenPreparadoNoTab
 * v.2.7  27/04/2023 Modificado export default connect para que haga el forwardRef
 * */

import React from 'react'

import PropTypes from 'prop-types';

import {Tab, Tabs, Icon} from "@blueprintjs/core";
import FormularioDatos from "./FormularioDatos";
import {prepararChildren} from "../utils/ComponentChildrenUtils";
import {connect} from "react-redux";
import {ACCION_NUEVO} from "./TiposAcciones";

class FormularioDatosMultiTab extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedTab: props.estado.tab ? props.estado.tab : "datos",
            elemento: {},
        }
    }


    //Para sustituir a WillṔrops
    /*
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.elemento !== prevState.elemento) {
            newState.elemento = nextProps.elemento;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }
    */

    onChangeTab = (tabId) => {
        //console.log("FormularioDatosMultiTab - onChangeTab");
        //console.log("tabId: ", tabId);
        this.setState({selectedTab: tabId});
    }

    render() {
        const {selectedTab} =  this.state;
        const {elementoConfig, elemento, accion, onCerrado, onGuardado, onAntesGuardar, children, elementoOrigen,
                dialogoTitulo, dialogoTexto, dialogoTipo, onDialogoCerrado,
                onAntesMostrar, onPermitirAceptar,
                usuario, auth} = this.props;

        let esNuevo= accion == ACCION_NUEVO;
        let childrenPreparado= !esNuevo &&  prepararChildren(elemento, children, true);
        let childrenPreparadoNoTab= prepararChildren(elemento, children, false);
        let accionesUsuario= auth.acciones;

        //console.log("FORMULARIODATOSMULTITAB - RENDER ");
        //console.log("childrenPreparado: ", childrenPreparado);

        return (
            <div className="formulariodatos">

                <Tabs id="Tabs"
                      onChange={this.onChangeTab}
                      selectedTabId={selectedTab}
                      animate={true}
                      renderActiveTabPanelOnly={true}
                      vertical={false}>
                    <Tab id="datos" title={<><Icon icon="paperclip"/> Datos </>}
                         panel={
                             <FormularioDatos elementoConfig={elementoConfig} elemento={elemento}
                                 accion={accion}
                                 onCerrado={onCerrado}
                                 onGuardado={onGuardado}
                                 onAntesGuardar={onAntesGuardar}
                                 onAntesMostrar={onAntesMostrar}
                                 elementoOrigen={elementoOrigen}
                                 dialogoTitulo={dialogoTitulo}
                                 dialogoTexto={dialogoTexto}
                                 dialogoTipo={dialogoTipo}
                                 onDialogoCerrado={onDialogoCerrado}
                                 onPermitirAceptar={onPermitirAceptar}
                                 usuario={usuario}
                             >
                                 {!esNuevo && childrenPreparadoNoTab}
                             </FormularioDatos>
                         }
                    />

                    {
                        (!esNuevo && childrenPreparado) &&
                        childrenPreparado.map( (child, index) => {
                            let mostrar= (!child.props.menuid || (accionesUsuario && accionesUsuario.includes(" " + child.props.menuid + " "))  )
                            if (mostrar)
                                return (
                                    <Tab
                                         title={<><Icon icon={child.props.icon} /> {child.props.titulo} </>}
                                         key={index} id={child.props.titulo}
                                         panel={<> {child} </>}
                                    />
                                );
                        })
                    }


                </Tabs>
            </div>
        );
    }
}
/*
(!esNuevo && childrenPreparado) &&
    childrenPreparado.map( (child, index) => {
        return (
            <Tab
                 title={child.props.titulo}
                 key={index} id={child.props.titulo} title={child.props.titulo}
                 panel={<> {child} </>}
            />
        );
    })

 */
FormularioDatosMultiTab.propTypes = {
    elementoConfig: PropTypes.object.isRequired,
    className: PropTypes.string,
    elemento: PropTypes.object,
    onValidar: PropTypes.func,
    onGuardar: PropTypes.func,
    onGuardado: PropTypes.func,
    onAntesGuardar: PropTypes.func,
    onAntesMostrar: PropTypes.func,
    onCerrado: PropTypes.func,

    dialogoTitulo: PropTypes.string,
    dialogoTexto: PropTypes.string,
    dialogoTipo: PropTypes.string,
    onDialogoCerrado: PropTypes.func,
    onPermitirAceptar: PropTypes.func,

    usuario: PropTypes.object,
}

const mapStateToProps = function(state) {
    return {
        estado: state.estado,
        auth: state.auth,
    }
}

//Necesitamos hacer el connect para poder hacer Dispatchs
//export default connect(mapStateToProps)(FormularioDatosMultiTab);
//HAcemos forwardRef para que los padres puedan usar <FormularioDatosMultiTab ref=...>
export default connect(mapStateToProps, null, null, { forwardRef: true })(FormularioDatosMultiTab);

